export const MAX_WIDTHS = {
  XXS: 'xxs',
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
};

export const ALIGNMENT = {
  top: 'start',
  center: 'center',
};
